import type { AirportExtended } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const airportsIdGet = (id: number) => coreRequestService<AirportExtended>({
    url: `/airports/${id}`,
    method: 'GET'
});
